import { keyframes } from 'styled-components/macro';

const ButtonShadow = keyframes`
0% {
  box-shadow: 0.4389924193300864px 0 1px #00ffd570, -0.4389924193300864px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
5% {
  box-shadow: 2.7928974010788217px 0 1px #00ffd570, -2.7928974010788217px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
10% {
  box-shadow: 0.02956275843481219px 0 1px #00ffd570, -0.02956275843481219px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
15% {
  box-shadow: 0.40218538552878136px 0 1px #00ffd570, -0.40218538552878136px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
20% {
  box-shadow: 3.4794037899852017px 0 1px #00ffd570, -3.4794037899852017px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
25% {
  box-shadow: 1.6125630401149584px 0 1px #00ffd570, -1.6125630401149584px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
30% {
  box-shadow: 0.7015590085143956px 0 1px #00ffd570, -0.7015590085143956px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
35% {
  box-shadow: 3.896914047650351px 0 1px #00ffd570, -3.896914047650351px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
40% {
  box-shadow: 3.870905614848819px 0 1px #00ffd570, -3.870905614848819px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
45% {
  box-shadow: 2.231056963361899px 0 1px #00ffd570, -2.231056963361899px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
50% {
  box-shadow: 0.08084290417898504px 0 1px #00ffd570, -0.08084290417898504px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
55% {
  box-shadow: 2.3758461067427543px 0 1px #00ffd570, -2.3758461067427543px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
60% {
  box-shadow: 2.202193051050636px 0 1px #00ffd570, -2.202193051050636px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
65% {
  box-shadow: 2.8638780614874975px 0 1px #00ffd570, -2.8638780614874975px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
70% {
  box-shadow: 0.48874025155497314px 0 1px #00ffd570, -0.48874025155497314px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
75% {
  box-shadow: 1.8948491305757957px 0 1px #00ffd570, -1.8948491305757957px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
80% {
  box-shadow: 0.0833037308038857px 0 1px #00ffd570, -0.0833037308038857px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
85% {
  box-shadow: 0.09769827255241735px 0 1px #00ffd570, -0.09769827255241735px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
90% {
  box-shadow: 3.443339761481782px 0 1px #00ffd570, -3.443339761481782px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
95% {
  box-shadow: 2.1841838852799786px 0 1px #00ffd570, -2.1841838852799786px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
100% {
  box-shadow: 2.6208764473832513px 0 1px #00ffd570, -2.6208764473832513px 0 1px rgba(255,0,80,0.3), 0 0 3px;
}
`;

export default ButtonShadow;
